import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { Container, Divider } from '@fiverr-private/layout_components';
import * as SuggestionsSelector from '../../../selectors/Suggestions';
import ChipsContainer from '../ChipsContainer';
import { aiPillTitleRevealClass } from '../styles.ve.css';
import QuickFilterChip from '../QuickFilterChip';

const QuickFilters = ({ ids, isLoading, query }) => {
    if (isLoading || !ids.length) {
        return null;
    }

    return (
        <Container marginTop="2" paddingX={{ default: 0, md: 4 }} paddingBottom="2">
            <Divider marginBottom="5" />
            <Container display="flex" flexDirection="column" gap="3">
                <Text size="b_md" fontWeight="bold" className={aiPillTitleRevealClass}>
                    <I18n k="search_bar.ai_pill.query_by_category" params={{ query }} />
                </Text>
                <ChipsContainer ids={ids} Chip={QuickFilterChip} />
            </Container>
        </Container>
    );
};

QuickFilters.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.string),
    isLoading: PropTypes.bool,
    query: PropTypes.string,
};

QuickFilters.defaultProps = {
    ids: [],
    isLoading: false,
    query: '',
};

const mapStateToProps = (state) => {
    const ids = SuggestionsSelector.categorySuggestionIds(state);

    return {
        ids,
        isLoading: SuggestionsSelector.isSuggestionsLoading(state),
        query: SuggestionsSelector.suggestionById(state, ids[0]).value,
    };
};

export { QuickFilters };
export default connect(mapStateToProps)(QuickFilters);
